/* LOUNGE CREW: estúdio "Faça a sua" (personalização de camisetas).
 *
 * Funil (mesmo do estúdio da Dimona): Selecione o produto e a cor → editor com Produto, Imagem, Estampas,
 * Texto e Camadas, Cores, 3D, Frente/Costas e Baixar → CONCLUIR gera a arte de produção (PNG 2700×3600,
 * 39×52 cm) e a prévia de cada lado e sobe para os Arquivos da Shopify → Quantidades por tamanho →
 * sacola (/cart/add.js com a propriedade "Personalização" = código da arte).
 *
 * O editor é um Fabric.js 5 (assets/lc-fabric.min.js). Tudo o que o cliente monta fica em coordenadas da
 * ÁREA DE IMPRESSÃO (600×800 unidades), então trocar cor ou caimento não mexe na arte.
 * O servidor que assina o upload e cria os arquivos é o do checkout (checkout-api/api/arte.js); o pedido
 * nasce no webhook com os links das artes (checkout-api/lib/pedido.js).
 */
(function () {
  'use strict';

  var dadosEl = document.getElementById('est-dados');
  if (!dadosEl) return;
  var D = JSON.parse(dadosEl.textContent);

  /* ------------------------------------------------------------ utilidades */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var brl = function (c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); };
  var semAcento = function (s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var ico = function (n) { return '<svg class="i" aria-hidden="true"><use href="#e-' + n + '"/></svg>'; };
  var celular = function () { return window.matchMedia('(max-width: 820px)').matches; };
  var toque = window.matchMedia('(pointer: coarse)').matches;
  var uid = function () { return Date.now().toString(36) + Math.random().toString(36).slice(2, 7); };
  function atraso(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }

  var CHAVE = 'lc-estudio-v1';
  var AREA = { w: 600, h: 800 };          // unidades da área de impressão
  var MEDIDA = { frente: '39 × 52 cm', costas: '44 × 59 cm' };   // a das costas é maior (pedido do Gabriel)
  var LARGURA_CM = { frente: 39, costas: 44 };
  var MULT_PRODUCAO = 4.5;                // arte final 2700 × 3600 px (~176 dpi na frente, ~156 nas costas)
  var LADOS = ['frente', 'costas'];
  var TAMANHOS = ['P', 'M', 'G', 'GG', 'XGG'];
  var PROPS = ['nome', 'tipoLC', 'travado', 'estampaId', 'formaRecorte'];
  var MODELOS = {
    ovr: {
      nome: 'Camiseta Oversized', opcao: 'Oversized',
      desc: 'Uma peça exclusiva, montada por você e produzida só para você. Ombro caído, manga mais larga e barra mais longa: o caimento boxy da Lounge Crew, em algodão pesado 260 g/m².',
      medidas: [['P', 56, 71, 22], ['M', 59, 73, 23], ['G', 62, 75, 24], ['GG', 65, 77, 25], ['XGG', 68, 79, 26]]
    },
    reg: {
      nome: 'Camiseta Regular', opcao: 'Regular',
      desc: 'Uma peça exclusiva, montada por você e produzida só para você. Veste no corpo, do jeito que você já usa: cerca de 8 cm mais estreita que a oversized. Algodão pesado 260 g/m².',
      medidas: [['P', 48, 68, 19], ['M', 51, 70, 20], ['G', 54, 72, 21], ['GG', 57, 74, 22], ['XGG', 60, 76, 23]]
    }
  };
  var CORES = [
    { k: 'preto', nome: 'Preto', hex: '#151515', escura: true },
    { k: 'branco', nome: 'Branco', hex: '#F7F6F2' },
    { k: 'areia', nome: 'Areia', hex: '#D8C3A1' },
    { k: 'cinza-estonado', nome: 'Cinza Estonado', hex: '#5B5A58', escura: true }
  ];
  var FONTES = [
    {'n': 'Inter Tight', 'g': 'sans', 'b': 700}, {'n': 'Montserrat', 'g': 'sans', 'b': 800, 'i': 1}, {'n': 'Oswald', 'g': 'sans', 'b': 700},
    {'n': 'Anton', 'g': 'sans'}, {'n': 'Archivo Black', 'g': 'sans'}, {'n': 'Bebas Neue', 'g': 'sans'},
    {'n': 'Barlow Condensed', 'g': 'sans', 'b': 700, 'i': 1}, {'n': 'Archivo', 'g': 'sans', 'b': 700}, {'n': 'Manrope', 'g': 'sans', 'b': 800},
    {'n': 'Poppins', 'g': 'sans', 'b': 700, 'i': 1}, {'n': 'Raleway', 'g': 'sans', 'b': 700}, {'n': 'Work Sans', 'g': 'sans', 'b': 700},
    {'n': 'Rubik', 'g': 'sans', 'b': 700}, {'n': 'Outfit', 'g': 'sans', 'b': 700}, {'n': 'Figtree', 'g': 'sans', 'b': 800},
    {'n': 'Space Grotesk', 'g': 'sans', 'b': 700}, {'n': 'Syne', 'g': 'sans', 'b': 800}, {'n': 'Unbounded', 'g': 'sans', 'b': 800},
    {'n': 'Chivo', 'g': 'sans', 'b': 700}, {'n': 'Teko', 'g': 'sans', 'b': 700}, {'n': 'Antonio', 'g': 'sans', 'b': 700},
    {'n': 'Saira Condensed', 'g': 'sans', 'b': 700}, {'n': 'Michroma', 'g': 'sans'}, {'n': 'Instrument Serif', 'g': 'serif', 'i': 1},
    {'n': 'Playfair Display', 'g': 'serif', 'b': 800, 'i': 1}, {'n': 'Bodoni Moda', 'g': 'serif', 'b': 700, 'i': 1},
    {'n': 'Cormorant Garamond', 'g': 'serif', 'b': 700, 'i': 1}, {'n': 'Cinzel', 'g': 'serif', 'b': 700}, {'n': 'Abril Fatface', 'g': 'serif'},
    {'n': 'DM Serif Display', 'g': 'serif', 'i': 1}, {'n': 'Libre Baskerville', 'g': 'serif', 'b': 700, 'i': 1},
    {'n': 'Lora', 'g': 'serif', 'b': 700, 'i': 1}, {'n': 'EB Garamond', 'g': 'serif', 'b': 700, 'i': 1}, {'n': 'Marcellus', 'g': 'serif'},
    {'n': 'Italiana', 'g': 'serif'}, {'n': 'Gloock', 'g': 'serif'}, {'n': 'Fraunces', 'g': 'serif', 'b': 900, 'i': 1}, {'n': 'Prata', 'g': 'serif'},
    {'n': 'Spectral', 'g': 'serif', 'b': 700, 'i': 1}, {'n': 'Noto Serif Display', 'g': 'serif', 'b': 700, 'i': 1},
    {'n': 'Alfa Slab One', 'g': 'display'}, {'n': 'Bowlby One', 'g': 'display'}, {'n': 'Rubik Mono One', 'g': 'display'},
    {'n': 'Ultra', 'g': 'display'}, {'n': 'Bungee', 'g': 'display'}, {'n': 'Monoton', 'g': 'display'}, {'n': 'Righteous', 'g': 'display'},
    {'n': 'Staatliches', 'g': 'display'}, {'n': 'Shrikhand', 'g': 'display'}, {'n': 'Special Elite', 'g': 'display'},
    {'n': 'Lacquer', 'g': 'display'}, {'n': 'Bungee Shade', 'g': 'display'}, {'n': 'Titan One', 'g': 'display'}, {'n': 'Rampart One', 'g': 'display'},
    {'n': 'Great Vibes', 'g': 'script'}, {'n': 'Yellowtail', 'g': 'script'}, {'n': 'Pacifico', 'g': 'script'}, {'n': 'Lobster', 'g': 'script'},
    {'n': 'Caveat', 'g': 'script', 'b': 700}, {'n': 'Permanent Marker', 'g': 'script'}, {'n': 'Dancing Script', 'g': 'script', 'b': 700},
    {'n': 'Sacramento', 'g': 'script'}, {'n': 'Parisienne', 'g': 'script'}, {'n': 'Allura', 'g': 'script'}, {'n': 'Pinyon Script', 'g': 'script'},
    {'n': 'Homemade Apple', 'g': 'script'}, {'n': 'Shadows Into Light', 'g': 'script'}, {'n': 'Rock Salt', 'g': 'script'},
    {'n': 'Reenie Beanie', 'g': 'script'}, {'n': 'Gochi Hand', 'g': 'script'}, {'n': 'Kalam', 'g': 'script', 'b': 700},
    {'n': 'Mr Dafoe', 'g': 'script'}, {'n': 'Sedgwick Ave', 'g': 'script'}, {'n': 'Nothing You Could Do', 'g': 'script'},
    {'n': 'Marck Script', 'g': 'script'}, {'n': 'Grand Hotel', 'g': 'script'}, {'n': 'JetBrains Mono', 'g': 'mono', 'b': 700},
    {'n': 'Space Mono', 'g': 'mono', 'b': 700, 'i': 1}, {'n': 'Courier Prime', 'g': 'mono', 'b': 700, 'i': 1},
    {'n': 'IBM Plex Mono', 'g': 'mono', 'b': 700, 'i': 1}, {'n': 'Roboto Mono', 'g': 'mono', 'b': 700},
    {'n': 'DM Mono', 'g': 'mono', 'b': 500, 'i': 1}
  ];

  var FONTES_CSS = 'https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Alfa+Slab+One&family=Allura&family=Anton&family=Antonio:wght@400;700&family=Archivo+Black&family=Archivo:wght@400;700&family=Barlow+Condensed:ital,wght@0,400;0,700;1,400;1,700&family=Bebas+Neue&family=Bodoni+Moda:ital,wght@0,400;0,700;1,400;1,700&family=Bowlby+One&family=Bungee&family=Bungee+Shade&family=Caveat:wght@400;700&family=Chivo:wght@400;700&family=Cinzel:wght@400;700&family=Cormorant+Garamond:ital,wght@0,400;0,700;1,400;1,700&family=Courier+Prime:ital,wght@0,400;0,700;1,400;1,700&family=DM+Mono:ital,wght@0,400;0,500;1,400;1,500&family=DM+Serif+Display:ital,wght@0,400;1,400&family=Dancing+Script:wght@400;700&family=EB+Garamond:ital,wght@0,400;0,700;1,400;1,700&family=Figtree:wght@400;800&family=Fraunces:ital,wght@0,400;0,900;1,400;1,900&family=Gloock&family=Gochi+Hand&family=Grand+Hotel&family=Great+Vibes&family=Homemade+Apple&family=IBM+Plex+Mono:ital,wght@0,400;0,700;1,400;1,700&family=Italiana&family=Kalam:wght@400;700&family=Lacquer&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400;1,700&family=Lobster&family=Lora:ital,wght@0,400;0,700;1,400;1,700&family=Manrope:wght@400;800&family=Marcellus&family=Marck+Script&family=Michroma&family=Monoton&family=Montserrat:ital,wght@0,400;0,800;1,400;1,800&family=Mr+Dafoe&family=Nothing+You+Could+Do&family=Noto+Serif+Display:ital,wght@0,400;0,700;1,400;1,700&family=Oswald:wght@400;700&family=Outfit:wght@400;700&family=Pacifico&family=Parisienne&family=Permanent+Marker&family=Pinyon+Script&family=Playfair+Display:ital,wght@0,400;0,800;1,400;1,800&family=Poppins:ital,wght@0,400;0,700;1,400;1,700&family=Prata&family=Raleway:wght@400;700&family=Rampart+One&family=Reenie+Beanie&family=Righteous&family=Roboto+Mono:wght@400;700&family=Rock+Salt&family=Rubik+Mono+One&family=Rubik:wght@400;700&family=Sacramento&family=Saira+Condensed:wght@400;700&family=Sedgwick+Ave&family=Shadows+Into+Light&family=Shrikhand&family=Space+Grotesk:wght@400;700&family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&family=Special+Elite&family=Spectral:ital,wght@0,400;0,700;1,400;1,700&family=Staatliches&family=Syne:wght@400;800&family=Teko:wght@400;700&family=Titan+One&family=Ultra&family=Unbounded:wght@400;800&family=Work+Sans:wght@400;700&family=Yellowtail&display=swap';
  var GRUPOS_FONTE = [['todas', 'Todas'], ['sans', 'Sem serifa'], ['serif', 'Serifa'], ['display', 'Display'], ['script', 'Manuscrita'], ['mono', 'Mono']];
  var infoFonte = function (f) { for (var i = 0; i < FONTES.length; i++) { if (FONTES[i].n === f) return FONTES[i]; } return null; };
  var cssFontes = false;
  function carregarFontesCss() {     // a folha do Google com 79 famílias só entra quando o cliente vai escrever
    if (cssFontes) return;
    cssFontes = true;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = FONTES_CSS; document.head.appendChild(l);
  }
  var PALETA = ['#151515', '#FFFFFF', '#F2EEE6', '#D8C3A1', '#B8914F', '#D9BC87', '#173B2F', '#6E7556', '#1F2A44', '#2F5DA8', '#8FB8DE', '#6A1F2B', '#C8102E', '#E4572E', '#F2A541', '#F4D35E', '#E86A92', '#7B4FA0', '#5B5A58', '#B9B8B6', '#8C877F'];

  var cor = function (k) { return CORES.filter(function (c) { return c.k === k; })[0] || CORES[0]; };
  var iCai = D.produto.opcoes.indexOf('Caimento'), iCor = D.produto.opcoes.indexOf('Cor'), iTam = D.produto.opcoes.indexOf('Tamanho');
  function variante(cai, k, tam) {
    return D.produto.variantes.filter(function (v) { return v.o[iCai] === MODELOS[cai].opcao && v.o[iCor] === cor(k).nome && v.o[iTam] === tam; })[0];
  }
  function preco(cai) {
    var ps = D.produto.variantes.filter(function (v) { return v.o[iCai] === MODELOS[cai].opcao; }).map(function (v) { return v.preco; });
    return ps.length ? Math.min.apply(null, ps) : 0;
  }
  var base = function (p, lado) { return D.bases[p.cai + '-' + lado + '-' + p.cor]; };

  /* ---------------------------------------------------------------- estado */
  var S = { projetos: [], atual: -1, lado: 'frente', zoom: 1, pan: { x: 0, y: 0 }, mao: false, painel: celular() ? null : 'imagem', modoProduto: 'novo', minhas: [] };
  var canvas;
  var proj = function () { return S.projetos[S.atual]; };

  var el = {
    corpo: $('[data-corpo]'), cena: $('[data-cena]'), peca: $('[data-peca]'), base: $('[data-base]'), area: $('[data-area]'),
    ferr: $('[data-ferr]'), painel: $('[data-painel]'), projetos: $('[data-projetos]'), vazio: $('[data-vazio]'), toast: $('[data-toast]')
  };

  function toast(msg) {
    el.toast.textContent = msg; el.toast.classList.add('on');
    clearTimeout(toast.t); toast.t = setTimeout(function () { el.toast.classList.remove('on'); }, 2800);
  }

  /* --------------------------------------------------------------- modais */
  function abrirModal(nome) { var m = $('[data-mod="' + nome + '"]'); m.hidden = false; return m; }
  function fecharModal(nome) { var m = $('[data-mod="' + nome + '"]'); if (m) m.hidden = true; if (nome === '3d') pararGiro(); }
  $$('[data-mod]').forEach(function (m) {
    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-fechar]') || (e.target === m && m.dataset.mod !== 'produto' && m.dataset.mod !== 'aviso')) {
        if (m.dataset.mod === 'produto' && !S.projetos.length) return;
        if (m.dataset.mod === 'recorte') return;
        fecharModal(m.dataset.mod);
      }
    });
  });

  function aviso(titulo, texto, botoes) {
    botoes = botoes || [{ t: 'Ok' }];
    var m = abrirModal('aviso');
    $('[data-aviso-titulo]', m).textContent = titulo;
    $('[data-aviso-texto]', m).textContent = texto;
    var box = $('[data-aviso-botoes]', m);
    box.innerHTML = botoes.map(function (b, i) { return '<button type="button" data-i="' + i + '" class="' + (b.perigo ? 'perigo' : '') + '">' + esc(b.t) + '</button>'; }).join('');
    return new Promise(function (ok) {
      box.onclick = function (e) {
        var b = e.target.closest('[data-i]'); if (!b) return;
        m.hidden = true; ok(Number(b.dataset.i));
      };
    });
  }

  /* ------------------------------------------------------------ carregar */
  function carregarScript(src) {
    return new Promise(function (ok, falha) { var s = document.createElement('script'); s.src = src; s.onload = ok; s.onerror = falha; document.head.appendChild(s); });
  }
  var cacheImg = {};
  function carregarImg(src) {
    if (!cacheImg[src]) {
      cacheImg[src] = new Promise(function (ok, falha) {
        var i = new Image(); i.crossOrigin = 'anonymous'; i.decoding = 'async';
        i.onload = function () { ok(i); }; i.onerror = function () { delete cacheImg[src]; falha(new Error('imagem ' + src)); };
        i.src = src;
      });
    }
    return cacheImg[src];
  }
  function garantirFonte(fam, peso, estilo) {
    carregarFontesCss();
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return document.fonts.load((estilo || 'normal') + ' ' + (peso || 400) + ' 40px "' + fam + '"').catch(function () {});
  }
  function fontesDosObjetos(objs) {
    return Promise.all(objs.filter(function (o) { return o.fontFamily; }).map(function (o) {
      return garantirFonte(o.fontFamily, o.fontWeight, o.fontStyle).then(function () {
        if (window.fabric) fabric.util.clearFabricFontCache(o.fontFamily);
        if (o.initDimensions) { o.initDimensions(); o.setCoords(); }
      });
    }));
  }

  /* --------------------------------------------------------------- palco */
  function medir() {
    var W = el.cena.clientWidth, H = el.cena.clientHeight;
    var desk = !celular();
    var esq = desk ? 16 + 80 + 16 + 48 + 16 + (S.painel ? (el.painel.offsetWidth || 312) - 6 : 0) : 8;
    var dir = desk ? 16 + 48 + 16 : 8;
    var topo = desk ? 16 + 44 + 18 : 60;
    var baixo = desk ? 16 : 10;
    var aw = Math.max(120, W - esq - dir), ah = Math.max(150, H - topo - baixo);
    // a foto tem fundo igual ao palco e margem em volta da peça: dá para ampliar um pouco além do encaixe
    var w = Math.min(aw * 1.08, ah * 0.8 * 1.2), h = w * 1.25;
    var cx = esq + aw / 2, cy = topo + ah / 2;
    w *= S.zoom; h *= S.zoom;
    return { W: W, H: H, x: cx - w / 2 + S.pan.x, y: cy - h / 2 + S.pan.y, w: w, h: h };
  }
  function layout() {
    var p = proj(); if (!p || !canvas) return;
    var b = base(p, S.lado);
    var r = medir();
    el.peca.style.width = r.w + 'px'; el.peca.style.height = r.h + 'px';
    el.peca.style.transform = 'translate(' + r.x + 'px,' + r.y + 'px)';
    if (el.base.getAttribute('src') !== b.img) el.base.src = b.img;
    var z = b.z;
    var zx = r.x + z[0] * r.w, zy = r.y + z[1] * r.h, zw = z[2] * r.w, zh = z[3] * r.h;
    el.area.style.left = zx + 'px'; el.area.style.top = zy + 'px'; el.area.style.width = zw + 'px'; el.area.style.height = zh + 'px';
    el.area.classList.toggle('escura', !!cor(p.cor).escura);
    var etq = $('.est-area__etq', el.area);
    if (etq) etq.textContent = 'Área de impressão · ' + MEDIDA[S.lado];
    if (canvas.getWidth() !== r.W || canvas.getHeight() !== r.H) canvas.setDimensions({ width: r.W, height: r.H });
    var s = zw / AREA.w;
    canvas.setViewportTransform([s, 0, 0, s, zx, zy]);
    S.vista = { zx: zx, zy: zy, zw: zw, zh: zh, s: s };
    canvas.requestRenderAll();
    posicionarFerramentas();
  }
  window.addEventListener('resize', atraso(layout, 60));

  /* ------------------------------------------------------------ projetos */
  function novoProjeto(cai, k) {
    guardarLado();
    S.projetos.push({ uid: uid(), cai: cai, cor: k, lados: { frente: [], costas: [] }, qtd: {}, envio: null, mini: {}, previaLocal: {} });
    abrirProjeto(S.projetos.length - 1, 'frente');
  }
  function guardarLado() { var p = proj(); if (p && canvas) p.lados[S.lado] = canvas.getObjects().slice(); }
  function abrirProjeto(i, lado) {
    guardarLado();
    S.atual = i; S.lado = lado || 'frente'; S.zoom = 1; S.pan = { x: 0, y: 0 };
    carregarLado();
    var p = proj();
    LADOS.forEach(function (l) { carregarImg(base(p, l).img).catch(function () {}); });
    atualizarProduto(); desenharProjetos(); salvar();
  }
  function carregarLado() {
    var p = proj(); if (!p) return;
    canvas.discardActiveObject();
    canvas.remove.apply(canvas, canvas.getObjects());
    p.lados[S.lado].forEach(function (o) { canvas.add(o); });
    $$('[data-lado]').forEach(function (b) { b.classList.toggle('on', b.dataset.lado === S.lado); });
    layout(); marcarLados(); desenharCamadas(); desenharFerramentas();
  }
  function trocarLado(lado) {
    if (lado === S.lado) return;
    guardarLado(); S.lado = lado; carregarLado();
  }
  function temArte(p, lado) {
    if (p === proj()) guardarLado();
    var ls = lado ? [lado] : LADOS;
    return ls.some(function (l) { return (p.lados[l] || []).some(function (o) { return o.visible !== false; }); });
  }
  function marcarLados() {
    guardarLado();
    var p = proj(); if (!p) return;
    $$('[data-lado]').forEach(function (b) { $('.ponto', b).hidden = !temArte(p, b.dataset.lado); });
    el.vazio.hidden = temArte(p);
  }

  function desenharProjetos() {
    el.projetos.innerHTML = S.projetos.map(function (p, i) {
      var lado = p.mini.frente ? 'frente' : (p.mini.costas ? 'costas' : 'frente');
      var src = p.mini[lado] || base(p, 'frente').img;
      return '<button type="button" class="proj' + (i === S.atual ? ' on' : '') + '" data-proj="' + i + '" aria-label="' + esc(MODELOS[p.cai].nome + ' ' + cor(p.cor).nome) + '"><img src="' + esc(src) + '" alt=""></button>';
    }).join('');
  }
  el.projetos.addEventListener('click', function (e) {
    var b = e.target.closest('[data-proj]'); if (!b) return;
    var i = Number(b.dataset.proj); if (i !== S.atual) abrirProjeto(i);
  });

  var miniatura = atraso(function () {
    var p = proj(); if (!p || !S.vista) return;
    var b = base(p, S.lado);
    carregarImg(b.img).then(function (img) {
      var c = document.createElement('canvas'); c.width = 92; c.height = 115;
      var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, 92, 115);
      if (temArte(p, S.lado)) {
        var dpr = canvas.getRetinaScaling(), v = S.vista, z = b.z;
        try { ctx.drawImage(canvas.lowerCanvasEl, v.zx * dpr, v.zy * dpr, v.zw * dpr, v.zh * dpr, z[0] * 92, z[1] * 115, z[2] * 92, z[3] * 115); } catch (e) {}
        p.mini[S.lado] = c.toDataURL('image/jpeg', 0.82);
      } else {
        delete p.mini[S.lado];
      }
      desenharProjetos();
    }).catch(function () {});
  }, 500);

  /* -------------------------------------------------------- salvar local */
  var salvar = atraso(function () {
    guardarLado();
    var dados = {
      v: 1, atual: S.atual,
      projetos: S.projetos.map(function (p) {
        return {
          uid: p.uid, cai: p.cai, cor: p.cor, qtd: p.qtd, mini: p.mini,
          lados: { frente: p.lados.frente.map(function (o) { return o.toObject(PROPS); }), costas: p.lados.costas.map(function (o) { return o.toObject(PROPS); }) }
        };
      })
    };
    try { localStorage.setItem(CHAVE, JSON.stringify(dados)); }
    catch (e) {
      // imagens grandes estouram a cota: guarda ao menos modelo, cor, textos e estampas
      try {
        dados.projetos.forEach(function (p) {
          p.mini = {};
          LADOS.forEach(function (l) { p.lados[l] = p.lados[l].filter(function (o) { return !(o.type === 'image' && /^data:/.test(o.src || '')); }); });
        });
        localStorage.setItem(CHAVE, JSON.stringify(dados));
      } catch (e2) {}
    }
  }, 700);

  function restaurar() {
    var dados = null;
    try { dados = JSON.parse(localStorage.getItem(CHAVE) || 'null'); } catch (e) {}
    if (!dados || !dados.projetos || !dados.projetos.length) return Promise.resolve(false);
    var fila = dados.projetos.filter(function (p) { return MODELOS[p.cai] && D.bases[p.cai + '-frente-' + p.cor]; }).map(function (p) {
      return Promise.all(LADOS.map(function (l) {
        return new Promise(function (ok) {
          fabric.util.enlivenObjects((p.lados && p.lados[l]) || [], function (objs) { ok(objs.filter(Boolean)); });
        });
      })).then(function (lados) {
        return fontesDosObjetos(lados[0].concat(lados[1])).then(function () {
          return { uid: p.uid || uid(), cai: p.cai, cor: p.cor, qtd: p.qtd || {}, envio: null, mini: p.mini || {}, previaLocal: {}, lados: { frente: lados[0], costas: lados[1] } };
        });
      });
    });
    return Promise.all(fila).then(function (ps) {
      if (!ps.length) return false;
      S.projetos = ps;
      S.atual = -1;
      abrirProjeto(Math.min(Math.max(0, dados.atual || 0), ps.length - 1), 'frente');
      return true;
    }).catch(function () { return false; });
  }

  /* ------------------------------------------------------------- produto */
  function desenharCards() {
    $('[data-cards]').innerHTML = Object.keys(MODELOS).map(function (k) {
      var m = MODELOS[k];
      return '<div class="card" data-card="' + k + '">' +
        '<div class="card__img" data-card-img><img src="' + esc(D.bases[k + '-frente-branco'].img) + '" alt="' + esc(m.nome) + '" loading="lazy">' +
        '<div class="card__sel"><strong>Selecione a cor</strong><div>' + CORES.map(function (c) {
          return '<button type="button" class="bola" style="background:' + c.hex + '" title="' + esc(c.nome) + '" aria-label="' + esc(m.nome + ' ' + c.nome) + '" data-escolher="' + k + '|' + c.k + '"></button>';
        }).join('') + '</div></div></div>' +
        '<h3>' + esc(m.nome) + '</h3>' +
        '<div class="minis">' + CORES.map(function (c) { return '<i style="background:' + c.hex + '" title="' + esc(c.nome) + '"></i>'; }).join('') + '</div>' +
        '<p class="card__de">A partir de</p><p class="card__preco">' + brl(preco(k)) + '</p>' +
        '<p class="card__nota">Peça exclusiva · frente, costas ou os dois lados</p></div>';
    }).join('');
  }
  $('[data-cards]').addEventListener('click', function (e) {
    var esc_ = e.target.closest('[data-escolher]');
    if (esc_) {
      var partes = esc_.dataset.escolher.split('|');
      fecharModal('produto');
      if (S.modoProduto === 'trocar' && proj()) {
        var p = proj(); p.cai = partes[0]; p.cor = partes[1]; p.envio = null;
        layout(); atualizarProduto(); miniatura(); salvar();
        toast(MODELOS[p.cai].nome + ' · ' + cor(p.cor).nome);
      } else {
        novoProjeto(partes[0], partes[1]);
        if (!celular() && !S.painel) abrirPainel('imagem');
      }
      return;
    }
    // no toque, o 1º toque abre as cores do card (sem hover); só o 2º escolhe
    var img = e.target.closest('[data-card-img]');
    if (img && !window.matchMedia('(hover: hover)').matches) {
      var card = img.closest('.card');
      $$('.card.aberto').forEach(function (c) { if (c !== card) c.classList.remove('aberto'); });
      card.classList.toggle('aberto');
    }
  });
  function abrirProdutos(modo) {
    S.modoProduto = modo;
    var m = abrirModal('produto');
    $('[data-fechar]', m).hidden = !S.projetos.length;
    $$('.card.aberto', m).forEach(function (c) { c.classList.remove('aberto'); });
  }
  function atualizarProduto() {
    var p = proj(); if (!p) return;
    var m = MODELOS[p.cai];
    $('[data-prod-nome]').textContent = m.nome;
    $('[data-prod-cor]').textContent = 'Cor: ' + cor(p.cor).nome;
    $('[data-prod-cor-bola]').style.background = cor(p.cor).hex;
    $('[data-prod-desc]').textContent = m.desc;
    $('[data-prod-preco]').textContent = brl(preco(p.cai));
    $('[data-prod-medidas]').innerHTML = m.medidas.map(function (l) { return '<tr><td><strong>' + l[0] + '</strong></td><td>' + l[1] + '</td><td>' + l[2] + '</td><td>' + l[3] + '</td></tr>'; }).join('');
  }

  /* ---------------------------------------------------------------- cores */
  function abrirCores() {
    var p = proj(); if (!p) return;
    var m = abrirModal('cores');
    $('[data-cores]', m).innerHTML = CORES.map(function (c) {
      return '<button type="button" class="bola' + (c.k === p.cor ? ' on' : '') + '" style="background:' + c.hex + '" title="' + esc(c.nome) + '" aria-label="' + esc(c.nome) + '" data-cor="' + c.k + '"></button>';
    }).join('');
  }
  $('[data-cores]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-cor]'); if (!b) return;
    var p = proj(); p.cor = b.dataset.cor; p.envio = null;
    fecharModal('cores'); layout(); atualizarProduto(); miniatura(); salvar();
  });

  /* --------------------------------------------------------------- painel */
  var TITULOS = { produto: 'Produto', imagem: 'Imagem', estampas: 'Estampas', texto: 'Criar texto', camadas: 'Camadas' };
  function abrirPainel(aba) {
    S.painel = aba;
    el.painel.hidden = false; el.painel.dataset.aba = aba;
    $('[data-painel-titulo]').textContent = TITULOS[aba];
    el.corpo.classList.remove('sem-painel');
    $$('.est-tab').forEach(function (t) { t.classList.toggle('on', t.dataset.aba === aba); });
    if (aba === 'estampas') desenharEstampas();
    if (aba === 'camadas') desenharCamadas();
    if (aba === 'texto') desenharFontes();
    layout();
  }
  function fecharPainel() {
    S.painel = null; el.painel.hidden = true;
    el.corpo.classList.add('sem-painel');
    $$('.est-tab').forEach(function (t) { t.classList.remove('on'); });
    layout();
  }
  $('.est-barra').addEventListener('click', function (e) {
    var t = e.target.closest('[data-aba]'); if (!t) return;
    if (S.painel === t.dataset.aba && !celular()) fecharPainel(); else abrirPainel(t.dataset.aba);
  });
  var fecharNoCelular = function () { if (celular()) fecharPainel(); };

  /* -------------------------------------------------------------- imagens */
  var arquivoEl = $('[data-arquivo]');
  function lerArquivos(lista) {
    Array.prototype.slice.call(lista || []).forEach(function (f) {
      if (!/^image\/(png|jpe?g|webp)$/i.test(f.type)) { aviso('Formato não aceito', 'Envie a imagem em PNG, JPG ou WEBP.'); return; }
      if (f.size > 10 * 1024 * 1024) { aviso('Imagem muito pesada', 'O peso máximo é 10MB. Exporte a imagem um pouco menor e tente de novo.'); return; }
      var url = URL.createObjectURL(f);
      carregarImg(url).then(function (img) {
        var maior = Math.max(img.naturalWidth, img.naturalHeight), lim = 3200, esc_ = Math.min(1, lim / maior);
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * esc_); c.height = Math.round(img.naturalHeight * esc_);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        var png = /png|webp/i.test(f.type);
        var src = c.toDataURL(png ? 'image/png' : 'image/jpeg', 0.92);
        URL.revokeObjectURL(url);
        var item = { src: src, nome: f.name.replace(/\.[a-z0-9]+$/i, '') };
        S.minhas.unshift(item); desenharMinhas();
        recortarEAdicionar(item);
      }).catch(function () { aviso('Erro', 'Não conseguimos abrir essa imagem. Tente outro arquivo.'); });
    });
  }
  function desenharMinhas() {
    $('[data-minhas-rot]').hidden = !S.minhas.length;
    $('[data-minhas]').innerHTML = S.minhas.slice(0, 12).map(function (m, i) { return '<button type="button" data-minha="' + i + '" aria-label="Adicionar ' + esc(m.nome) + '"><img src="' + m.src + '" alt=""></button>'; }).join('');
  }
  $('[data-minhas]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-minha]'); if (!b) return;
    recortarEAdicionar(S.minhas[Number(b.dataset.minha)]);
  });
  arquivoEl.addEventListener('change', function () { lerArquivos(arquivoEl.files); arquivoEl.value = ''; });
  var drop = $('[data-drop]');
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('sobre'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('sobre'); }); });
  drop.addEventListener('drop', function (e) { e.preventDefault(); lerArquivos(e.dataTransfer.files); });
  el.cena.addEventListener('dragover', function (e) { e.preventDefault(); });
  el.cena.addEventListener('drop', function (e) { e.preventDefault(); if (e.dataTransfer && e.dataTransfer.files.length) lerArquivos(e.dataTransfer.files); });

  // várias imagens de uma vez: o recorte abre uma por vez
  var filaRecorte = Promise.resolve();
  function recortarEAdicionar(item) {
    filaRecorte = filaRecorte.then(function () {
      return abrirRecorte({ src: item.src, novo: true }).then(function (r) {
        if (r) adicionarImagem(item.src, { nome: item.nome, tipoLC: 'imagem' }, r);
      });
    });
  }
  function adicionarImagem(src, extra, recorte) {
    if (!proj()) return;
    fabric.Image.fromURL(src, function (img) {
      if (!img || !img.width) { aviso('Erro', 'Não conseguimos carregar essa imagem.'); return; }
      if (recorte) {
        img.set({ cropX: recorte.x, cropY: recorte.y, width: recorte.w, height: recorte.h });
        aplicarForma(img, recorte.forma);
      }
      var escala = Math.min(AREA.w * 0.8 / img.width, AREA.h * 0.8 / img.height);
      img.set(Object.assign({ left: AREA.w / 2, top: AREA.h * 0.42, originX: 'center', originY: 'center', scaleX: escala, scaleY: escala }, extra || {}));
      adicionar(img);
      avisarResolucao(img);
    }, { crossOrigin: 'anonymous' });
  }
  function dpi(o) {
    if (o.type !== 'image' || !o._element) return 999;
    var larguraPol = (o.getScaledWidth() / AREA.w) * (LARGURA_CM[S.lado] / 2.54);
    return o.width / larguraPol;   // width = pixels da imagem que sobraram depois do recorte
  }
  function avisarResolucao(o) {
    if (o.tipoLC === 'imagem' && dpi(o) < 90) toast('Imagem com resolução baixa para esse tamanho: pode sair sem nitidez.');
  }

  /* -------------------------------------------------------------- recorte */
  // Recorte NÃO destrutivo: a imagem inteira fica guardada e o Fabric mostra só cropX/cropY/width/height
  // (e um clipPath elíptico no formato círculo). Dá para recortar de novo e voltar à imagem inteira.
  var recEl = {
    mod: $('[data-mod="recorte"]'), palco: $('[data-rec-palco]'), img: $('[data-rec-img]'), caixa: $('[data-rec-caixa]'),
    info: $('[data-rec-info]'), aplicar: $('[data-rec-aplicar]'), inteira: $('[data-rec-inteira]')
  };
  var R = null;
  function aplicarForma(o, forma) {
    o.formaRecorte = forma === 'circulo' ? 'circulo' : 'retangulo';
    o.set('clipPath', o.formaRecorte === 'circulo' ? new fabric.Ellipse({ rx: o.width / 2, ry: o.height / 2, originX: 'center', originY: 'center', left: 0, top: 0 }) : null);
  }
  function abrirRecorte(op) {
    return new Promise(function (ok) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        var W = im.naturalWidth, H = im.naturalHeight;
        R = { W: W, H: H, c: op.crop ? { x: op.crop.x, y: op.crop.y, w: op.crop.w, h: op.crop.h } : { x: 0, y: 0, w: W, h: H }, forma: op.forma || 'retangulo', prop: null, fim: ok, novo: !!op.novo };
        recEl.img.src = op.src;
        recEl.aplicar.textContent = op.novo ? 'Aplicar e colocar na camiseta' : 'Aplicar recorte';
        recEl.inteira.textContent = op.novo ? 'Usar imagem inteira' : 'Cancelar';
        $$('[data-prop]', recEl.mod).forEach(function (b) { b.classList.toggle('on', b.dataset.prop === 'livre'); });
        $$('[data-forma]', recEl.mod).forEach(function (b) { b.classList.toggle('on', b.dataset.forma === R.forma); });
        recEl.mod.hidden = false;
        fecharPops(); el.toast.classList.remove('on');
        requestAnimationFrame(recLayout);
      };
      im.onerror = function () { aviso('Erro', 'Não conseguimos abrir essa imagem para recortar.'); ok(null); };
      im.src = op.src;
    });
  }
  function recFechar(resultado) {
    if (!R) return;
    var fim = R.fim; R = null; recEl.mod.hidden = true;
    fim(resultado);
  }
  function recLayout() {
    if (!R || recEl.mod.hidden) return;
    var pw = recEl.palco.clientWidth, ph = recEl.palco.clientHeight, pad = celular() ? 18 : 30;
    R.k = Math.min((pw - pad * 2) / R.W, (ph - pad * 2) / R.H);
    R.ox = (pw - R.W * R.k) / 2; R.oy = (ph - R.H * R.k) / 2;
    recEl.img.style.width = R.W * R.k + 'px'; recEl.img.style.height = R.H * R.k + 'px';
    recEl.img.style.transform = 'translate(' + R.ox + 'px,' + R.oy + 'px)';
    recDesenhar();
  }
  window.addEventListener('resize', atraso(recLayout, 60));
  function recDesenhar() {
    var c = R.c, k = R.k, cx = recEl.caixa.style;
    cx.left = (R.ox + c.x * k) + 'px'; cx.top = (R.oy + c.y * k) + 'px'; cx.width = (c.w * k) + 'px'; cx.height = (c.h * k) + 'px';
    recEl.caixa.classList.toggle('circulo', R.forma === 'circulo');
    var w = Math.round(c.w), h = Math.round(c.h);
    var cmW = w / 150 * 2.54, cmH = h / 150 * 2.54;
    recEl.info.innerHTML = 'Recorte: <strong>' + w + ' × ' + h + ' px</strong><br>' + (cmW >= 44 || cmH >= 59
      ? 'Boa nitidez mesmo ocupando a área inteira de impressão.'
      : 'Boa nitidez até cerca de <strong>' + Math.max(1, Math.round(cmW)) + ' × ' + Math.max(1, Math.round(cmH)) + ' cm</strong> na camiseta.');
  }
  var limitar = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  function recRedimensionar(h, ini, dx, dy) {
    var W = R.W, H = R.H, min = Math.max(8, Math.round(Math.min(W, H) * 0.03));
    if (h === 'mover') return { x: limitar(ini.x + dx, 0, W - ini.w), y: limitar(ini.y + dy, 0, H - ini.h), w: ini.w, h: ini.h };
    var x1 = ini.x, y1 = ini.y, x2 = ini.x + ini.w, y2 = ini.y + ini.h;
    var temW = h.indexOf('w') > -1, temE = h.indexOf('e') > -1, temN = h.indexOf('n') > -1, temS = h.indexOf('s') > -1;
    if (temW) x1 = limitar(x1 + dx, 0, x2 - min);
    if (temE) x2 = limitar(x2 + dx, x1 + min, W);
    if (temN) y1 = limitar(y1 + dy, 0, y2 - min);
    if (temS) y2 = limitar(y2 + dy, y1 + min, H);
    var r = R.prop;
    if (r) {
      var w = x2 - x1, hh = y2 - y1;
      if (h === 'n' || h === 's') w = hh * r;
      else if (h === 'e' || h === 'w') hh = w / r;
      else if (w / hh > r) w = hh * r; else hh = w / r;
      // âncora: o lado/canto oposto ao que está sendo puxado (ou o meio, nas bordas)
      var ax = temW ? x2 : (temE ? x1 : (x1 + x2) / 2), ay = temN ? y2 : (temS ? y1 : (y1 + y2) / 2);
      var maxW = temW ? ax : (temE ? W - ax : 2 * Math.min(ax, W - ax));
      var maxH = temN ? ay : (temS ? H - ay : 2 * Math.min(ay, H - ay));
      var esc_ = Math.min(1, maxW / w, maxH / hh); w *= esc_; hh *= esc_;
      x1 = temW ? ax - w : (temE ? ax : ax - w / 2);
      y1 = temN ? ay - hh : (temS ? ay : ay - hh / 2);
      x2 = x1 + w; y2 = y1 + hh;
    }
    return { x: x1, y: y1, w: x2 - x1, h: y2 - y1 };
  }
  function recProporcao(v) {
    R.prop = v === 'livre' ? null : (v === 'original' ? R.W / R.H : Number(v));
    $$('[data-prop]', recEl.mod).forEach(function (b) { b.classList.toggle('on', b.dataset.prop === v); });
    if (!R.prop) return recDesenhar();
    var cx = R.c.x + R.c.w / 2, cy = R.c.y + R.c.h / 2;
    var w = Math.min(R.c.w, R.c.h * R.prop), h = w / R.prop;
    if (w < 24 || h < 24) { w = Math.min(R.W, R.H * R.prop); h = w / R.prop; }
    R.c = { x: limitar(cx - w / 2, 0, R.W - w), y: limitar(cy - h / 2, 0, R.H - h), w: w, h: h };
    recDesenhar();
  }
  (function () {
    var arr = null;
    recEl.palco.addEventListener('pointerdown', function (e) {
      if (!R) return;
      var alvo = e.target.closest('[data-h]'), h = alvo ? alvo.dataset.h : null, ini = R.c;
      if (!h) {
        // tocar fora da área desenha um recorte novo a partir dali
        var px = (e.clientX - recEl.palco.getBoundingClientRect().left - R.ox) / R.k, py = (e.clientY - recEl.palco.getBoundingClientRect().top - R.oy) / R.k;
        if (px < 0 || py < 0 || px > R.W || py > R.H) return;
        h = 'se'; ini = { x: px, y: py, w: 0, h: 0 };
      }
      e.preventDefault();
      arr = { h: h, x: e.clientX, y: e.clientY, ini: { x: ini.x, y: ini.y, w: ini.w, h: ini.h } };
      recEl.palco.setPointerCapture(e.pointerId);
    });
    recEl.palco.addEventListener('pointermove', function (e) {
      if (!arr || !R) return;
      R.c = recRedimensionar(arr.h, arr.ini, (e.clientX - arr.x) / R.k, (e.clientY - arr.y) / R.k);
      recDesenhar();
    });
    var soltar = function () { arr = null; };
    recEl.palco.addEventListener('pointerup', soltar);
    recEl.palco.addEventListener('pointercancel', soltar);
  })();
  recEl.mod.addEventListener('click', function (e) {
    if (!R) return;
    var b;
    if ((b = e.target.closest('[data-prop]'))) return recProporcao(b.dataset.prop);
    if ((b = e.target.closest('[data-forma]'))) {
      R.forma = b.dataset.forma;
      $$('[data-forma]', recEl.mod).forEach(function (x) { x.classList.toggle('on', x === b); });
      if (R.forma === 'circulo' && !R.prop) recProporcao('1');
      return recDesenhar();
    }
    if (e.target.closest('[data-rec-restaurar]')) { R.c = { x: 0, y: 0, w: R.W, h: R.H }; R.forma = 'retangulo'; recProporcao('livre'); $$('[data-forma]', recEl.mod).forEach(function (x) { x.classList.toggle('on', x.dataset.forma === 'retangulo'); }); return; }
    if (e.target.closest('[data-rec-cancelar]') || e.target === recEl.mod) return recFechar(null);
    if (e.target.closest('[data-rec-inteira]')) return recFechar(R.novo ? { x: 0, y: 0, w: R.W, h: R.H, forma: 'retangulo' } : null);
    if (e.target.closest('[data-rec-aplicar]')) {
      var c = R.c;
      var x = Math.round(limitar(c.x, 0, R.W - 1)), y = Math.round(limitar(c.y, 0, R.H - 1));
      return recFechar({ x: x, y: y, w: Math.max(1, Math.min(Math.round(c.w), R.W - x)), h: Math.max(1, Math.min(Math.round(c.h), R.H - y)), forma: R.forma });
    }
  });
  // recorta de novo uma imagem que já está na camiseta, mantendo no lugar o pedaço que sobrou
  function abrirRecorteObjeto(o) {
    if (!o || o.type !== 'image') return;
    var elm = o.getElement();
    abrirRecorte({ src: o.getSrc(), crop: { x: o.cropX || 0, y: o.cropY || 0, w: o.width, h: o.height }, forma: o.formaRecorte }).then(function (r) {
      if (!r) return;
      var cx0 = (o.cropX || 0) + o.width / 2, cy0 = (o.cropY || 0) + o.height / 2;
      var dx = (r.x + r.w / 2 - cx0) * o.scaleX * (o.flipX ? -1 : 1), dy = (r.y + r.h / 2 - cy0) * o.scaleY * (o.flipY ? -1 : 1);
      var ang = fabric.util.degreesToRadians(o.angle || 0), centro = o.getCenterPoint();
      var novo = new fabric.Point(centro.x + dx * Math.cos(ang) - dy * Math.sin(ang), centro.y + dx * Math.sin(ang) + dy * Math.cos(ang));
      o.set({ cropX: r.x, cropY: r.y, width: r.w, height: r.h });
      aplicarForma(o, r.forma);
      o.setPositionByOrigin(novo, 'center', 'center');
      o.dirty = true; o.setCoords();
      if (elm && canvas.getObjects().indexOf(o) > -1) canvas.setActiveObject(o);
      canvas.requestRenderAll(); depoisDeMudar();
      setTimeout(function () { avisarResolucao(o); }, 150);
    });
  }

  /* ------------------------------------------------------------- estampas */
  var buscaEl = $('[data-busca]');
  var GRUPOS = ['Joias e relógios', 'Drinks e comida', 'Moda e beleza', 'Carros, iates e jatos', 'Viagem', 'Animais', 'Casa e lifestyle', 'Esporte e clube', 'Ícones', 'Selos vintage'];
  S.grupo = '';
  // "Todas" intercala as categorias: a primeira tela já mostra variedade
  var estampasTodas = (function () {
    var filas = GRUPOS.map(function (g) { return (D.estampas || []).filter(function (e) { return (e.grupo || e.cat) === g; }); });
    var resto = (D.estampas || []).filter(function (e) { return GRUPOS.indexOf(e.grupo || e.cat) < 0; });
    var out = [], max = Math.max.apply(null, filas.map(function (f) { return f.length; }).concat([0]));
    for (var i = 0; i < max; i++) filas.forEach(function (f) { if (f[i]) out.push(f[i]); });
    return out.concat(resto);
  })();
  // nichos: atalhos de busca (as palavras-chave de cada estampa vêm de estudio/palavras_estampas.py)
  var NICHOS = ['Praia', 'Festa', 'Amor', 'Dinheiro', 'Drinks', 'Carros', 'Viagem', 'Inverno', 'Animais', 'Joias', 'Brasil', 'Sorte', 'Flores', 'Vintage', 'Pop art', 'Dourado'];
  function desenharGrupos() {
    var cont = {}; (D.estampas || []).forEach(function (e) { var g = e.grupo || e.cat; cont[g] = (cont[g] || 0) + 1; });
    $('[data-grupos]').innerHTML = '<option value="">Todas as categorias (' + (D.estampas || []).length + ')</option>' +
      GRUPOS.filter(function (g) { return cont[g]; }).map(function (g) { return '<option value="' + esc(g) + '"' + (S.grupo === g ? ' selected' : '') + '>' + esc(g) + ' (' + cont[g] + ')</option>'; }).join('');
    $('[data-grupos]').value = S.grupo;
  }
  function desenharNichos() {
    var q = semAcento(buscaEl.value).trim();
    $('[data-nichos]').innerHTML = NICHOS.map(function (n) { return '<button type="button" class="' + (semAcento(n) === q ? 'on' : '') + '" data-nicho="' + esc(n) + '">' + esc(n) + '</button>'; }).join('');
  }
  $('[data-grupos]').addEventListener('change', function (e) { S.grupo = e.target.value; desenharEstampas(); });
  $('[data-nichos]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-nicho]'); if (!b) return;
    var ja = b.classList.contains('on');
    buscaEl.value = ja ? '' : b.dataset.nicho;
    S.grupo = ''; desenharGrupos(); desenharEstampas();
  });
  var PARADAS = { de: 1, da: 1, do: 1, das: 1, dos: 1, e: 1, com: 1, em: 1, a: 1, o: 1, para: 1 };
  function desenharEstampas() {
    if (!$('[data-grupos]').options.length) desenharGrupos();
    desenharNichos();
    var termos = semAcento(buscaEl.value).split(/[^a-z0-9]+/).filter(function (w) { return w && !PARADAS[w]; });
    var lista = estampasTodas.filter(function (e) {
      if (S.grupo && (e.grupo || e.cat) !== S.grupo) return false;
      if (!termos.length) return true;
      var feno = e._busca || (e._busca = semAcento([e.nome, e.grupo, e.cat, e.dica, e.tags, e.id].join(' ')));
      // todas as palavras precisam aparecer (aceita plural: "carros" acha "carro")
      return termos.every(function (w) { return feno.indexOf(w) > -1 || (w.length > 3 && /s$/.test(w) && feno.indexOf(w.replace(/e?s$/, '')) > -1); });
    });
    $('[data-conta]').textContent = lista.length + (lista.length === 1 ? ' estampa' : ' estampas');
    $('[data-grade]').innerHTML = lista.length ? lista.map(function (e) {
      return '<button type="button" data-estampa="' + esc(e.id) + '" title="' + esc(e.nome) + '"><img src="' + esc(e.url) + '?width=300" alt="' + esc(e.nome) + '" loading="lazy"></button>';
    }).join('') : '<p class="grade__vazio">Nenhuma estampa para “' + esc(buscaEl.value) + '”' + (S.grupo ? ' em ' + esc(S.grupo) : '') + '. Tente: ' +
      NICHOS.slice(0, 6).map(function (n) { return '<button type="button" data-nicho="' + esc(n) + '">' + esc(n) + '</button>'; }).join(', ') + '.</p>';
  }
  buscaEl.addEventListener('input', atraso(desenharEstampas, 150));
  $('[data-grade]').addEventListener('click', function (e) {
    var n = e.target.closest('[data-nicho]');
    if (n) { buscaEl.value = n.dataset.nicho; S.grupo = ''; desenharGrupos(); desenharEstampas(); return; }
    var b = e.target.closest('[data-estampa]'); if (!b) return;
    var est = D.estampas.filter(function (x) { return x.id === b.dataset.estampa; })[0]; if (!est) return;
    adicionarImagem(est.url, { nome: est.nome, tipoLC: 'estampa', estampaId: est.id });
    fecharNoCelular();
  });

  /* --------------------------------------------------------------- fontes */
  var fFiltro = { q: '', g: 'todas' };
  function fontesFiltradas() {
    var q = semAcento(fFiltro.q);
    return FONTES.filter(function (f) {
      return (fFiltro.g === 'todas' || f.g === fFiltro.g) && (!q || semAcento(f.n).indexOf(q) >= 0);
    });
  }
  // cada amostra só recebe a fonte quando aparece na tela: 79 famílias de uma vez pesariam o celular
  var obsFonte = window.IntersectionObserver ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.style.fontFamily = "'" + e.target.dataset.amostra + "'";
      obsFonte.unobserve(e.target);
    });
  }, { rootMargin: '250px' }) : null;
  function itemFonte(f, atual) {
    var am = ' data-amostra="' + esc(f.n) + '"';
    return '<button type="button" class="fitem' + (f.n === atual ? ' on' : '') + '" data-fonte="' + esc(f.n) + '">' +
      '<span class="fitem__aa"' + am + '>Aa</span><span class="fitem__nm"' + am + '>' + esc(f.n) + '</span></button>';
  }
  function ligarAmostras(raiz) {
    $$('[data-amostra]', raiz).forEach(function (s) {
      if (obsFonte) obsFonte.observe(s); else s.style.fontFamily = "'" + s.dataset.amostra + "'";
    });
  }
  function fonteAtiva() {
    var o = canvas && canvas.getActiveObject();
    return o && o.tipoLC === 'texto' ? o.fontFamily : '';
  }
  function desenharFontes() {
    carregarFontesCss();
    var cats = $('[data-fcats]'), alvo = $('[data-fontes]');
    if (!cats || !alvo) return;
    cats.innerHTML = GRUPOS_FONTE.map(function (g) {
      return '<button type="button" class="fchip' + (fFiltro.g === g[0] ? ' on' : '') + '" data-fgrupo="' + g[0] + '">' + g[1] + '</button>';
    }).join('');
    var lista = fontesFiltradas(), atual = fonteAtiva();
    alvo.innerHTML = lista.length ? lista.map(function (f) { return itemFonte(f, atual); }).join('')
      : '<p class="fvazio">Nenhuma fonte com esse nome.</p>';
    var conta = $('[data-fconta]');
    if (conta) conta.textContent = lista.length === FONTES.length ? FONTES.length + ' fontes' : lista.length + ' de ' + FONTES.length;
    ligarAmostras(alvo);
  }
  function usarFonte(fam) {
    var o = canvas.getActiveObject();
    if (o && o.tipoLC === 'texto') { trocarFonte(o, fam); desenharFontes(); desenharFerramentas(); return; }
    var inf = infoFonte(fam) || {};
    adicionar(texto('SEU TEXTO', { fontFamily: fam, fontSize: 56, fontWeight: inf.b || 400 }));
    setTimeout(desenharFontes, 80);
  }

  /* ---------------------------------------------------------------- texto */
  function corTexto() { var p = proj(); return p && cor(p.cor).escura ? '#FFFFFF' : '#151515'; }
  function texto(t, o) {
    return new fabric.IText(t, Object.assign({
      left: AREA.w / 2, top: AREA.h * 0.4, originX: 'center', originY: 'center', fontFamily: 'Inter Tight', fontSize: 48,
      fill: corTexto(), textAlign: 'center', tipoLC: 'texto', lineHeight: 1.05, editingBorderColor: '#173B2F', cursorColor: '#173B2F'
    }, o || {}));
  }
  $('.pn--texto').addEventListener('click', function (e) {
    var b = e.target.closest('[data-texto]');
    if (b) {
      var cfg = { g: ['TEXTO GRANDE', 72, 700], m: ['TEXTO MÉDIO', 48, 600], p: ['Texto pequeno', 30, 500] }[b.dataset.texto];
      adicionar(texto(cfg[0], { fontSize: cfg[1], fontWeight: cfg[2] }));
      fecharNoCelular();
      return;
    }
    var gr = e.target.closest('[data-fgrupo]');
    if (gr) { fFiltro.g = gr.dataset.fgrupo; desenharFontes(); return; }
    var ff = e.target.closest('[data-fonte]');
    if (ff) { usarFonte(ff.dataset.fonte); return; }
    var pr = e.target.closest('[data-preset]'); if (!pr) return;
    var c = corTexto(), ouro = '#B8914F', objs;
    switch (pr.dataset.preset) {
      case 'clube': objs = [
        texto('OLD MONEY', { fontFamily: 'Cinzel', fontWeight: 700, fontSize: 70, charSpacing: 120, top: 300 }),
        texto('social club', { fontFamily: 'Great Vibes', fontSize: 80, fill: ouro, top: 372 }),
        texto('EST. 2026', { fontFamily: 'Inter Tight', fontWeight: 500, fontSize: 20, charSpacing: 600, top: 440 })]; break;
      case 'champagne': objs = [
        texto('Champagne', { fontFamily: 'Yellowtail', fontSize: 120, fill: ouro, top: 330 }),
        texto('PROBLEMS ONLY', { fontFamily: 'Bebas Neue', fontSize: 52, charSpacing: 300, top: 420 })]; break;
      case 'lista': objs = [
        texto('Iate&\nVilla&\nChampagne&\nCaviar.', { fontFamily: 'Archivo Black', fontSize: 62, textAlign: 'left', lineHeight: 0.95, top: 360 })]; break;
      default: objs = [
        texto('NEVER LATE.', { fontFamily: 'Anton', fontSize: 96, top: 330 }),
        texto('just expensive.', { fontFamily: 'Instrument Serif', fontStyle: 'italic', fontSize: 64, top: 415 })];
    }
    fontesDosObjetos(objs).then(function () {
      objs.forEach(function (o) { canvas.add(o); });
      if (objs.length > 1) canvas.setActiveObject(new fabric.ActiveSelection(objs, { canvas: canvas }));
      else canvas.setActiveObject(objs[0]);
      canvas.requestRenderAll(); depoisDeMudar(); fecharNoCelular();
    });
  });

  var buscaFonteEl = $('[data-busca-fonte]');
  if (buscaFonteEl) buscaFonteEl.addEventListener('input', atraso(function () { fFiltro.q = buscaFonteEl.value; desenharFontes(); }, 120));

  /* ----------------------------------------------------------- adicionar */
  function adicionar(o) {
    if (!proj()) return;
    fontesDosObjetos([o]).then(function () {
      canvas.add(o); canvas.setActiveObject(o); canvas.requestRenderAll();
      depoisDeMudar(); fecharNoCelular();
    });
  }
  function depoisDeMudar() {
    var p = proj(); if (p) p.envio = null;
    marcarLados(); desenharCamadas(); desenharFerramentas(); miniatura(); salvar();
  }

  /* ------------------------------------------------------------- camadas */
  function nomeObj(o) {
    if (o.type === 'i-text' || o.type === 'text' || o.type === 'textbox') return (o.text || 'Texto').replace(/\s+/g, ' ').slice(0, 40);
    return (o.tipoLC === 'estampa' ? 'Estampa · ' : 'Imagem · ') + (o.nome || 'sem nome');
  }
  function desenharCamadas() {
    var box = $('[data-camadas]'); if (!box || !canvas) return;
    var objs = canvas.getObjects().slice().reverse();
    var ativos = canvas.getActiveObjects();
    box.innerHTML = objs.length ? objs.map(function (o) {
      var i = canvas.getObjects().indexOf(o);
      return '<div class="cam' + (ativos.indexOf(o) > -1 ? ' on' : '') + '" data-cam="' + i + '">' +
        '<div class="cam__ord"><button type="button" data-cam-acao="subir" aria-label="Subir camada">' + ico('seta-cima') + '</button><button type="button" data-cam-acao="descer" aria-label="Descer camada">' + ico('seta-baixo') + '</button></div>' +
        '<button type="button" class="cam__nome" data-cam-acao="selecionar">' + esc(nomeObj(o)) + '</button>' +
        '<button type="button" class="cam__acao" data-cam-acao="travar" aria-label="Travar">' + ico(o.travado ? 'cadeado' : 'cadeado-aberto') + '</button>' +
        '<button type="button" class="cam__acao" data-cam-acao="excluir" aria-label="Excluir">' + ico('lixo') + '</button>' +
        '<button type="button" class="cam__acao" data-cam-acao="ocultar" aria-label="Mostrar ou ocultar">' + ico(o.visible === false ? 'olho-off' : 'olho') + '</button></div>';
    }).join('') : '<p class="cam-vazio">Nenhuma camada neste lado ainda. Adicione uma imagem, estampa ou texto.</p>';
  }
  $('[data-camadas]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-cam-acao]'); if (!b) return;
    var o = canvas.getObjects()[Number(b.closest('[data-cam]').dataset.cam)]; if (!o) return;
    switch (b.dataset.camAcao) {
      case 'subir': o.bringForward(); break;
      case 'descer': o.sendBackwards(); break;
      case 'selecionar': if (o.visible !== false) { canvas.setActiveObject(o); fecharNoCelular(); } break;
      case 'travar': travar(o, !o.travado); break;
      case 'excluir': canvas.remove(o); break;
      case 'ocultar': o.visible = o.visible === false; if (!o.visible) canvas.discardActiveObject(); break;
    }
    canvas.requestRenderAll(); depoisDeMudar();
  });
  function travar(o, sim) {
    o.travado = sim;
    o.set({ lockMovementX: sim, lockMovementY: sim, lockScalingX: sim, lockScalingY: sim, lockRotation: sim, hasControls: !sim, editable: !sim });
  }

  /* ----------------------------------------------------------- ferramentas */
  var ehTexto = function (o) { return o && (o.type === 'i-text' || o.type === 'textbox' || o.type === 'text'); };
  function desenharFerramentas() {
    fecharPops();
    var o = canvas && canvas.getActiveObject();
    if (!o) { el.ferr.hidden = true; el.ferr.innerHTML = ''; return; }
    var fim = '<div class="est-ferr__grupo est-ferr__fim"><span class="sep"></span>' +
      '<button type="button" class="tb" data-t="duplicar" title="Duplicar">' + ico('copiar') + '</button>' +
      (o.type === 'activeSelection' ? '' : '<button type="button" class="tb" data-t="ocultar" title="Ocultar">' + ico('olho') + '</button>' +
        '<button type="button" class="tb' + (o.travado ? ' on' : '') + '" data-t="travar" title="' + (o.travado ? 'Destravar' : 'Travar') + '">' + ico(o.travado ? 'cadeado' : 'cadeado-aberto') + '</button>') +
      '<button type="button" class="tb" data-t="excluir" title="Excluir">' + ico('lixo') + '</button></div>';
    var comum = '<button type="button" class="tb" data-t="centralizar" title="Centralizar na área">' + ico('centro') + '</button>' +
      '<button type="button" class="tb" data-t="frente-camada" title="Trazer para frente">' + ico('frente-camada') + '</button>' +
      '<button type="button" class="tb" data-t="tras-camada" title="Enviar para trás">' + ico('tras-camada') + '</button>' +
      '<button type="button" class="tb" data-t="endireitar" title="Endireitar (0°)">' + ico('girar') + '</button>';
    var html;
    if (ehTexto(o)) {
      var al = { left: 'al-esq', center: 'al-centro', right: 'al-dir' }[o.textAlign] || 'al-centro';
      html = '<div class="est-ferr__grupo">' +
        '<button type="button" class="tb tb--fonte" data-t="fonte" title="Fonte"><span style="font-family:\'' + esc(o.fontFamily) + '\'">' + esc(o.fontFamily) + '</span>' + ico('chev') + '</button>' +
        '<div class="tam"><button type="button" data-t="tam-menos" aria-label="Diminuir">−</button><input type="number" inputmode="numeric" data-t-tam value="' + Math.round(o.fontSize) + '" aria-label="Tamanho da fonte"><button type="button" data-t="tam-mais" aria-label="Aumentar">+</button></div>' +
        '<button type="button" class="tb tb--edit" data-t="editar">Editar texto</button>' +
        '<button type="button" class="tb" data-t="cor" title="Cor do texto"><span class="cor-a">A<i style="background:' + esc(o.fill) + '"></i></span></button>' +
        '<button type="button" class="tb' + (Number(o.fontWeight) >= 600 || o.fontWeight === 'bold' ? ' on' : '') + '" data-t="negrito" title="Negrito">' + ico('negrito') + '</button>' +
        '<button type="button" class="tb' + (o.fontStyle === 'italic' ? ' on' : '') + '" data-t="italico" title="Itálico">' + ico('italico') + '</button>' +
        '<button type="button" class="tb' + (o.underline ? ' on' : '') + '" data-t="sublinhado" title="Sublinhado">' + ico('sublinhado') + '</button>' +
        '<button type="button" class="tb" data-t="alinhar" title="Alinhamento">' + ico(al) + '</button>' +
        '<button type="button" class="tb" data-t="espaco" title="Espaçamento">' + ico('espaco') + '</button>' +
        '<button type="button" class="tb" data-t="contorno" title="Contorno">' + ico('contorno') + '</button>' +
        '<button type="button" class="tb" data-t="opacidade" title="Opacidade">' + ico('opacidade') + '</button>' +
        '<span class="sep"></span>' + comum + '</div>';
    } else if (o.type === 'image') {
      html = '<div class="est-ferr__grupo">' +
        '<button type="button" class="tb tb--edit" data-t="recortar" title="Recortar imagem">' + ico('recortar') + 'Recortar</button>' +
        '<button type="button" class="tb" data-t="preencher" title="Ajustar à área de impressão">' + ico('preencher') + '</button>' +
        '<button type="button" class="tb' + (o.flipX ? ' on' : '') + '" data-t="espelho-h" title="Espelhar na horizontal">' + ico('espelho-h') + '</button>' +
        '<button type="button" class="tb' + (o.flipY ? ' on' : '') + '" data-t="espelho-v" title="Espelhar na vertical">' + ico('espelho-v') + '</button>' +
        '<button type="button" class="tb" data-t="opacidade" title="Opacidade">' + ico('opacidade') + '</button>' +
        '<span class="sep"></span>' + comum + '</div>';
    } else {
      html = '<div class="est-ferr__grupo">' + comum + '</div>';
    }
    el.ferr.innerHTML = html + fim;
    el.ferr.hidden = false;
  }
  function posicionarFerramentas() { /* a barra é fixa no topo do palco, como na Dimona */ }

  function mexer(fn) {
    var o = canvas.getActiveObject(); if (!o) return;
    fn(o); if (o.setCoords) o.setCoords(); canvas.requestRenderAll(); depoisDeMudar();
  }
  function refonte(x) {
    x.initDimensions();
    garantirFonte(x.fontFamily, x.fontWeight, x.fontStyle).then(function () {
      fabric.util.clearFabricFontCache(x.fontFamily); x.initDimensions(); x.setCoords(); canvas.requestRenderAll();
    });
  }
  function trocarFonte(o, fam) {
    var inf = infoFonte(fam) || {};
    // peso e itálico que a família não tem sairiam sintetizados pelo navegador (feios na arte de produção)
    var peso = Number(o.fontWeight) >= 500 ? (inf.b || 400) : (o.fontWeight || 400);
    var estilo = o.fontStyle === 'italic' && !inf.i ? 'normal' : (o.fontStyle || 'normal');
    garantirFonte(fam, peso, estilo).then(function () {
      fabric.util.clearFabricFontCache(fam);
      o.set({ fontFamily: fam, fontWeight: peso, fontStyle: estilo });
      o.initDimensions(); o.setCoords(); canvas.requestRenderAll(); depoisDeMudar();
    });
  }
  el.ferr.addEventListener('click', function (e) {
    var b = e.target.closest('[data-t]'); if (!b) return;
    var o = canvas.getActiveObject(); if (!o) return;
    var t = b.dataset.t;
    switch (t) {
      case 'fonte': return popFontes(b, o);
      case 'cor': return popCor(b, o);
      case 'espaco': return popEspaco(b, o);
      case 'contorno': return popContorno(b, o);
      case 'opacidade': return popOpacidade(b, o);
      case 'editar': return editarTexto(o);
      case 'recortar': return abrirRecorteObjeto(o);
      case 'tam-menos': case 'tam-mais': return mexer(function (x) { x.set('fontSize', Math.max(6, Math.min(400, Math.round(x.fontSize + (t === 'tam-mais' ? 2 : -2))))); x.initDimensions(); });
      case 'negrito': return mexer(function (x) { var n = !(Number(x.fontWeight) >= 600 || x.fontWeight === 'bold'); x.set('fontWeight', n ? 700 : 400); refonte(x); });
      case 'italico': return mexer(function (x) { x.set('fontStyle', x.fontStyle === 'italic' ? 'normal' : 'italic'); refonte(x); });
      case 'sublinhado': return mexer(function (x) { x.set('underline', !x.underline); });
      case 'alinhar': return mexer(function (x) { x.set('textAlign', { left: 'center', center: 'right', right: 'left' }[x.textAlign] || 'center'); });
      case 'centralizar': return mexer(function (x) { x.setPositionByOrigin(new fabric.Point(AREA.w / 2, x.getCenterPoint().y), 'center', 'center'); });
      case 'preencher': return mexer(function (x) {
        var s = Math.min(AREA.w / x.width, AREA.h / x.height);
        x.set({ scaleX: s, scaleY: s, angle: 0 }); x.setPositionByOrigin(new fabric.Point(AREA.w / 2, AREA.h / 2), 'center', 'center');
      });
      case 'espelho-h': return mexer(function (x) { x.set('flipX', !x.flipX); });
      case 'espelho-v': return mexer(function (x) { x.set('flipY', !x.flipY); });
      case 'frente-camada': return mexer(function (x) { x.bringToFront(); });
      case 'tras-camada': return mexer(function (x) { x.sendToBack(); });
      case 'endireitar': return mexer(function (x) { x.rotate(0); });
      case 'duplicar': return duplicar();
      case 'ocultar': o.visible = false; canvas.discardActiveObject(); canvas.requestRenderAll(); toast('Camada oculta. Mostre de novo em Camadas.'); return depoisDeMudar();
      case 'travar': travar(o, !o.travado); canvas.requestRenderAll(); return depoisDeMudar();
      case 'excluir': return excluir();
    }
  });
  el.ferr.addEventListener('change', function (e) {
    if (!e.target.matches('[data-t-tam]')) return;
    var v = Math.max(6, Math.min(400, Number(e.target.value) || 12));
    mexer(function (x) { x.set('fontSize', v); x.initDimensions(); });
  });
  function duplicar() {
    var o = canvas.getActiveObject(); if (!o) return;
    o.clone(function (c) {
      canvas.discardActiveObject();
      c.set({ left: c.left + 24, top: c.top + 24, evented: true });
      if (c.type === 'activeSelection') {
        c.canvas = canvas;
        c.forEachObject(function (x) { canvas.add(x); });
        c.setCoords();
      } else {
        canvas.add(c);
      }
      canvas.setActiveObject(c); canvas.requestRenderAll(); depoisDeMudar();
    }, PROPS);
  }
  function excluir() {
    var objs = canvas.getActiveObjects(); if (!objs.length) return;
    canvas.discardActiveObject(); canvas.remove.apply(canvas, objs); canvas.requestRenderAll(); depoisDeMudar();
  }

  /* popovers */
  function fecharPops() { $$('.pop').forEach(function (p) { p.remove(); }); }
  function pop(ancora, html) {
    fecharPops();
    var p = document.createElement('div'); p.className = 'pop'; p.innerHTML = html;
    document.body.appendChild(p);
    var r = ancora.getBoundingClientRect(), w = p.offsetWidth, h = p.offsetHeight;
    var left = Math.max(8, Math.min(window.innerWidth - w - 8, r.left));
    var top = r.bottom + 8; if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 8);
    p.style.position = 'fixed'; p.style.left = left + 'px'; p.style.top = top + 'px';
    return p;
  }
  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest('.pop') && !e.target.closest('[data-t]')) fecharPops();
    if (!e.target.closest('.est-top__dir')) { $('[data-menu]').hidden = true; }
  });
  function popFontes(b, o) {
    carregarFontesCss();
    var p = pop(b, '<div class="fontes"><label class="fontes-busca">' + ico('busca') +
      '<input type="search" placeholder="Buscar fonte" data-pop-busca autocomplete="off"></label>' +
      '<div class="fontes-lista" data-pop-lista></div></div>');
    p.classList.add('pop--fontes'); p.style.padding = '0';
    var desenhar = function () {
      var q = semAcento($('[data-pop-busca]', p).value), alvo = $('[data-pop-lista]', p);
      var lista = FONTES.filter(function (f) { return !q || semAcento(f.n).indexOf(q) >= 0; });
      alvo.innerHTML = lista.length ? lista.map(function (f) { return itemFonte(f, o.fontFamily); }).join('')
        : '<p class="fvazio">Nenhuma fonte com esse nome.</p>';
      ligarAmostras(alvo);
    };
    desenhar();
    $('[data-pop-busca]', p).addEventListener('input', atraso(desenhar, 120));
    p.addEventListener('click', function (e) {
      var x = e.target.closest('[data-fonte]'); if (!x) return;
      trocarFonte(o, x.dataset.fonte); fecharPops();
    });
  }
  function popCor(b, o) {
    var atual = String(o.fill || '').toUpperCase();
    var p = pop(b, '<p class="pop__t">Cor do texto</p><div class="paleta">' + PALETA.map(function (c) { return '<button type="button" class="' + (c === atual ? 'on' : '') + '" style="background:' + c + '" data-c="' + c + '" aria-label="' + c + '"></button>'; }).join('') + '</div>' +
      '<label class="pop__linha">Outra cor <input type="color" value="' + (/^#[0-9a-f]{6}$/i.test(atual) ? atual : '#151515') + '" data-c-livre></label>');
    p.addEventListener('click', function (e) { var x = e.target.closest('[data-c]'); if (!x) return; mexer(function (y) { y.set('fill', x.dataset.c); }); desenharFerramentas(); });
    $('[data-c-livre]', p).addEventListener('input', function (e) { var v = e.target.value; var ob = canvas.getActiveObject(); if (ob) { ob.set('fill', v); canvas.requestRenderAll(); } });
    $('[data-c-livre]', p).addEventListener('change', function () { depoisDeMudar(); });
  }
  function faixa(rotulo, chave, min, max, passo, valor, fmt) {
    return '<label class="pop__linha">' + rotulo + '<input type="range" min="' + min + '" max="' + max + '" step="' + passo + '" value="' + valor + '" data-r="' + chave + '"><output>' + fmt(valor) + '</output></label>';
  }
  function ligarFaixas(p, aplicar, fmts) {
    p.addEventListener('input', function (e) {
      var r = e.target.closest('[data-r]'); if (!r) return;
      var v = Number(r.value); r.nextElementSibling.textContent = fmts[r.dataset.r](v);
      var o = canvas.getActiveObject(); if (!o) return;
      aplicar(o, r.dataset.r, v); if (o.initDimensions) o.initDimensions(); o.setCoords(); canvas.requestRenderAll();
    });
    p.addEventListener('change', function () { depoisDeMudarSemFerramentas(); });
  }
  function depoisDeMudarSemFerramentas() { var p = proj(); if (p) p.envio = null; marcarLados(); desenharCamadas(); miniatura(); salvar(); }
  function popEspaco(b, o) {
    var fm = { cs: function (v) { return String(v); }, lh: function (v) { return v.toFixed(2); } };
    var p = pop(b, '<p class="pop__t">Espaçamento</p>' + faixa('Letras', 'cs', -100, 1000, 10, o.charSpacing || 0, fm.cs) + faixa('Linhas', 'lh', 0.6, 2.5, 0.05, o.lineHeight || 1, fm.lh));
    p.style.minWidth = '260px';
    ligarFaixas(p, function (x, k, v) { x.set(k === 'cs' ? 'charSpacing' : 'lineHeight', v); }, fm);
  }
  function popContorno(b, o) {
    var fm = { sw: function (v) { return String(v); } };
    var p = pop(b, '<p class="pop__t">Contorno</p>' + faixa('Espessura', 'sw', 0, 12, 0.5, o.strokeWidth && o.stroke ? o.strokeWidth : 0, fm.sw) +
      '<label class="pop__linha">Cor do contorno <input type="color" value="' + (/^#[0-9a-f]{6}$/i.test(o.stroke || '') ? o.stroke : '#151515') + '" data-contorno-cor></label>');
    p.style.minWidth = '260px';
    ligarFaixas(p, function (x, k, v) { x.set({ strokeWidth: v, stroke: v > 0 ? ($('[data-contorno-cor]', p).value) : null, paintFirst: 'stroke', strokeLineJoin: 'round' }); }, fm);
    $('[data-contorno-cor]', p).addEventListener('input', function (e) { var x = canvas.getActiveObject(); if (x && x.strokeWidth > 0) { x.set('stroke', e.target.value); canvas.requestRenderAll(); } });
  }
  function popOpacidade(b, o) {
    var fm = { op: function (v) { return v + '%'; } };
    var p = pop(b, '<p class="pop__t">Opacidade</p>' + faixa('', 'op', 10, 100, 1, Math.round((o.opacity == null ? 1 : o.opacity) * 100), fm.op));
    ligarFaixas(p, function (x, k, v) { x.set('opacity', v / 100); }, fm);
  }

  function editarTexto(o) {
    var m = abrirModal('editar');
    var campo = $('[data-editar-campo]', m);
    campo.value = o.text; S.editando = o;
    setTimeout(function () { campo.focus(); campo.select(); }, 30);
  }
  $('[data-acao="salvar-texto"]').addEventListener('click', function () {
    var o = S.editando, v = $('[data-editar-campo]').value;
    fecharModal('editar');
    if (!o) return;
    if (!v.trim()) { canvas.remove(o); } else { o.set('text', v); o.initDimensions(); o.setCoords(); }
    canvas.requestRenderAll(); depoisDeMudar();
  });

  /* -------------------------------------------------------------- teclado */
  document.addEventListener('keydown', function (e) {
    if (!canvas) return;
    var alvo = e.target, digitando = alvo.matches && alvo.matches('input,textarea,select,[contenteditable]');
    var o = canvas.getActiveObject();
    if (e.key === 'Escape') { fecharPops(); if (!$('[data-mod="aviso"]').hidden) return; if (R) { recFechar(null); return; } ['cores', 'editar', '3d'].forEach(fecharModal); if (S.projetos.length) fecharModal('produto'); return; }
    if (digitando || !o || (o.isEditing) || R) return;
    if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); excluir(); return; }
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'd') { e.preventDefault(); duplicar(); return; }
    var passo = e.shiftKey ? 10 : 2, d = { ArrowLeft: [-passo, 0], ArrowRight: [passo, 0], ArrowUp: [0, -passo], ArrowDown: [0, passo] }[e.key];
    if (d && !o.travado) { e.preventDefault(); o.set({ left: o.left + d[0], top: o.top + d[1] }); o.setCoords(); canvas.requestRenderAll(); depoisDeMudarSemFerramentas(); }
  });

  /* ------------------------------------------------------------ mão/zoom */
  var arrasto = null;
  function alternarMao(sim) {
    S.mao = sim;
    $('[data-acao="mao"]').classList.toggle('on', sim);
    el.cena.classList.toggle('mao', sim);
    canvas.selection = !sim; canvas.skipTargetFind = sim; canvas.defaultCursor = sim ? 'grab' : 'default';
    if (sim) { canvas.discardActiveObject(); canvas.requestRenderAll(); toast('Arraste para mover · role ou use os dedos para ampliar'); }
    else { S.zoom = 1; S.pan = { x: 0, y: 0 }; layout(); }
  }
  el.cena.addEventListener('pointerdown', function (e) { if (!S.mao) return; arrasto = { x: e.clientX, y: e.clientY, px: S.pan.x, py: S.pan.y }; el.cena.classList.add('arrastando'); });
  window.addEventListener('pointermove', function (e) { if (!arrasto) return; S.pan.x = arrasto.px + e.clientX - arrasto.x; S.pan.y = arrasto.py + e.clientY - arrasto.y; layout(); });
  window.addEventListener('pointerup', function () { arrasto = null; el.cena.classList.remove('arrastando'); });
  el.cena.addEventListener('wheel', function (e) {
    if (!S.mao && !e.ctrlKey) return;
    e.preventDefault();
    S.zoom = Math.max(1, Math.min(3, S.zoom * (e.deltaY < 0 ? 1.08 : 1 / 1.08)));
    if (S.zoom === 1) S.pan = { x: 0, y: 0 };
    layout();
  }, { passive: false });

  /* ---------------------------------------------------- render das artes */
  function renderArte(objs, mult) {
    var json = objs.filter(function (o) { return o.visible !== false; }).map(function (o) { return o.toObject(PROPS); });
    return new Promise(function (ok) {
      fabric.util.enlivenObjects(json, function (vivos) {
        var sc = new fabric.StaticCanvas(null, { width: AREA.w, height: AREA.h, enableRetinaScaling: false, renderOnAddRemove: false });
        vivos.filter(Boolean).forEach(function (o) { o.objectCaching = false; sc.add(o); });
        fontesDosObjetos(vivos.filter(Boolean)).then(function () {
          var teto = [fabric.perfLimitSizeTotal, fabric.maxCacheSideLimit];
          fabric.perfLimitSizeTotal = 64 * 1024 * 1024; fabric.maxCacheSideLimit = 8192;
          var c;
          try { c = sc.toCanvasElement(mult); } finally { fabric.perfLimitSizeTotal = teto[0]; fabric.maxCacheSideLimit = teto[1]; }
          sc.dispose();
          ok(c);
        });
      });
    });
  }
  // relevo do tecido: passa-alta da própria foto aplicado com soft-light só onde há tinta
  function textura(img, z, W, H) {
    var zx = Math.round(z[0] * W), zy = Math.round(z[1] * H), zw = Math.round(z[2] * W), zh = Math.round(z[3] * H);
    var t = document.createElement('canvas'); t.width = zw; t.height = zh;
    var tc = t.getContext('2d');
    tc.drawImage(img, z[0] * img.naturalWidth, z[1] * img.naturalHeight, z[2] * img.naturalWidth, z[3] * img.naturalHeight, 0, 0, zw, zh);
    var p = document.createElement('canvas'); p.width = Math.max(1, Math.round(zw / 18)); p.height = Math.max(1, Math.round(zh / 18));
    p.getContext('2d').drawImage(t, 0, 0, p.width, p.height);
    var bl = document.createElement('canvas'); bl.width = zw; bl.height = zh;
    var bc = bl.getContext('2d'); bc.imageSmoothingEnabled = true; bc.imageSmoothingQuality = 'high'; bc.drawImage(p, 0, 0, zw, zh);
    var a = tc.getImageData(0, 0, zw, zh), b = bc.getImageData(0, 0, zw, zh), da = a.data, db = b.data;
    for (var i = 0; i < da.length; i += 4) {
      var l1 = da[i] * 0.299 + da[i + 1] * 0.587 + da[i + 2] * 0.114;
      var l2 = db[i] * 0.299 + db[i + 1] * 0.587 + db[i + 2] * 0.114;
      var v = Math.max(0, Math.min(255, 128 + (l1 - l2) * 2.4));
      da[i] = da[i + 1] = da[i + 2] = v; da[i + 3] = 255;
    }
    tc.putImageData(a, 0, 0);
    return { c: t, x: zx, y: zy, w: zw, h: zh };
  }
  function renderPrevia(p, lado, arte, largura) {
    var W = largura || 1000, H = Math.round(W * 1.25), b = base(p, lado);
    return carregarImg(b.img).then(function (img) {
      var c = document.createElement('canvas'); c.width = W; c.height = H;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, W, H);
      if (!arte) return c;
      var tx = textura(img, b.z, W, H);
      var d = document.createElement('canvas'); d.width = tx.w; d.height = tx.h;
      var dc = d.getContext('2d'); dc.imageSmoothingQuality = 'high'; dc.drawImage(arte, 0, 0, tx.w, tx.h);
      var tc = tx.c.getContext('2d'); tc.globalCompositeOperation = 'destination-in'; tc.drawImage(d, 0, 0);
      ctx.globalAlpha = 0.97; ctx.drawImage(d, tx.x, tx.y); ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'soft-light'; ctx.drawImage(tx.c, tx.x, tx.y);
      ctx.globalCompositeOperation = 'source-over';
      return c;
    });
  }
  var paraBlob = function (c, tipo, q) { return new Promise(function (ok, falha) { c.toBlob(function (b) { b ? ok(b) : falha(new Error('toBlob')); }, tipo, q); }); };

  /* ---------------------------------------------------------------- baixar */
  function baixar() {
    guardarLado();
    var p = proj(); if (!p) return;
    var lado = S.lado;
    var arteP = temArte(p, lado) ? renderArte(p.lados[lado], 2) : Promise.resolve(null);
    arteP.then(function (arte) { return renderPrevia(p, lado, arte, 1200); }).then(function (c) { return paraBlob(c, 'image/jpeg', 0.9); }).then(function (blob) {
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'lounge-crew-' + p.cai + '-' + p.cor + '-' + lado + '.jpg';
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
    }).catch(function () { aviso('Erro', 'Não foi possível gerar a imagem agora. Tente de novo.'); });
  }

  /* -------------------------------------------------------------------- 3D */
  var giro = { ang: 0, raf: 0, auto: true };
  function abrir3d() {
    guardarLado();
    var p = proj(); if (!p) return;
    var m = abrirModal('3d');
    Promise.all(LADOS.map(function (l) {
      return (temArte(p, l) ? renderArte(p.lados[l], 1.4) : Promise.resolve(null)).then(function (a) { return renderPrevia(p, l, a, 840); });
    })).then(function (cs) {
      $('[data-giro-frente]', m).src = cs[0].toDataURL('image/jpeg', 0.88);
      $('[data-giro-costas]', m).src = cs[1].toDataURL('image/jpeg', 0.88);
      giro.ang = S.lado === 'costas' ? 180 : 0; giro.auto = true; aplicarGiro();
      cancelAnimationFrame(giro.raf);
      var passo = function () { if (giro.auto) { giro.ang += 0.9; aplicarGiro(); } giro.raf = requestAnimationFrame(passo); };
      giro.raf = requestAnimationFrame(passo);
    });
  }
  // a peça gira no eixo vertical: encolhe até o perfil e volta mostrando o outro lado (fundo igual ao palco)
  function aplicarGiro() {
    var c = Math.cos(giro.ang * Math.PI / 180), cartao = $('[data-giro-cartao]');
    cartao.style.transform = 'scaleX(' + Math.max(0.015, Math.abs(c)).toFixed(3) + ')';
    cartao.classList.toggle('verso', c < 0);
  }
  function pararGiro() { cancelAnimationFrame(giro.raf); }
  (function () {
    var g = $('[data-giro]'), ini = null;
    g.addEventListener('pointerdown', function (e) { giro.auto = false; ini = { x: e.clientX, a: giro.ang }; g.setPointerCapture(e.pointerId); });
    g.addEventListener('pointermove', function (e) { if (!ini) return; giro.ang = ini.a + (e.clientX - ini.x) * 0.6; aplicarGiro(); });
    g.addEventListener('pointerup', function () { ini = null; });
  })();

  /* ------------------------------------------------------------- concluir */
  function assinatura(p) {
    var s = p.cai + '|' + p.cor + '|' + JSON.stringify(LADOS.map(function (l) { return p.lados[l].map(function (o) { return o.toObject(PROPS); }); }));
    var h = 0; for (var i = 0; i < s.length; i++) { h = ((h << 5) - h + s.charCodeAt(i)) | 0; }
    return s.length + ':' + h;
  }
  function api(caminho, corpo) {
    return fetch(D.api + caminho, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corpo) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) { var e = new Error(j.mensagem || ('HTTP ' + r.status)); e.dados = j; throw e; } return j; }); });
  }
  function subir(alvo, blob, nome) {
    var fd = new FormData();
    alvo.parametros.forEach(function (p) { fd.append(p.name, p.value); });
    fd.append('file', blob, nome);
    var tentar = function (n) {
      return fetch(alvo.url, { method: 'POST', body: fd }).then(function (r) {
        if (r.status !== 201 && !r.ok) throw new Error('upload ' + r.status);
      }).catch(function (e) { if (n > 0) return new Promise(function (ok) { setTimeout(ok, 1200); }).then(function () { return tentar(n - 1); }); throw e; });
    };
    return tentar(2);
  }
  var ladosTexto = function (ls) { return ls.length === 2 ? 'Frente e costas' : (ls[0] === 'frente' ? 'Frente' : 'Costas'); };

  function gerando(i, n) {
    var g = $('[data-gerando]'); g.hidden = false;
    var pct = n ? Math.round((i - 1) / n * 100) : 0;
    $('[data-gerando-texto]').textContent = 'Gerando imagem ' + i + ' de ' + n + '… (' + pct + '%)';
    $('[data-gerando-barra]').style.width = pct + '%';
  }
  function enviarProjeto(p, passo) {
    var lados = LADOS.filter(function (l) { return temArte(p, l); });
    var arquivos = [], alertas = [];
    return lados.reduce(function (cadeia, lado) {
      return cadeia.then(function () {
        passo();
        p.lados[lado].forEach(function (o) { if (o.visible !== false && o.tipoLC === 'imagem' && dpi(o) < 90 && alertas.indexOf(o.nome) < 0) alertas.push(o.nome || 'imagem'); });
        return renderArte(p.lados[lado], MULT_PRODUCAO).then(function (arte) {
          return paraBlob(arte, 'image/png').then(function (bArte) {
            return renderPrevia(p, lado, arte, 1000).then(function (prev) { return paraBlob(prev, 'image/jpeg', 0.88); }).then(function (bPrev) {
              if (p.previaLocal[lado]) URL.revokeObjectURL(p.previaLocal[lado]);
              p.previaLocal[lado] = URL.createObjectURL(bPrev);
              arquivos.push({ nome: 'arte-' + lado + '.png', tipo: 'image/png', blob: bArte }, { nome: 'previa-' + lado + '.jpg', tipo: 'image/jpeg', blob: bPrev });
            });
          });
        });
      });
    }, Promise.resolve()).then(function () {
      return api('/arte', { acao: 'preparar', loja: D.loja, arquivos: arquivos.map(function (a) { return { nome: a.nome, tipo: a.tipo, tamanho: a.blob.size }; }) });
    }).then(function (prep) {
      return Promise.all(prep.alvos.map(function (alvo, i) { return subir(alvo, arquivos[i].blob, arquivos[i].nome); })).then(function () {
        return api('/arte', { acao: 'confirmar', loja: D.loja, id: prep.id, k: prep.k, arquivos: prep.alvos.map(function (a) { return { nome: a.nome, resourceUrl: a.resourceUrl }; }) });
      }).then(function (conf) {
        p.envio = { id: prep.id, urls: conf.urls || {}, assinatura: assinatura(p), lados: lados, alertas: alertas };
      });
    });
  }
  function concluir() {
    guardarLado();
    fecharPops();
    var validos = S.projetos.filter(function (p) { return temArte(p); });
    if (!validos.length) { aviso('Quase lá', 'Adicione uma imagem, estampa ou texto na camiseta antes de concluir.'); return; }
    canvas.discardActiveObject(); canvas.requestRenderAll();
    var pend = validos.filter(function (p) { return !p.envio || p.envio.assinatura !== assinatura(p); });
    var n = pend.reduce(function (s, p) { return s + LADOS.filter(function (l) { return temArte(p, l); }).length; }, 0), i = 0;
    if (!n) { abrirQuantidades(); return; }
    gerando(1, n);
    var passo = function () { i++; gerando(i, n); };
    pend.reduce(function (c, p) { return c.then(function () { return enviarProjeto(p, passo); }); }, Promise.resolve())
      .then(function () {
        $('[data-gerando-barra]').style.width = '100%';
        setTimeout(function () { $('[data-gerando]').hidden = true; abrirQuantidades(); }, 250);
      })
      .catch(function (e) {
        $('[data-gerando]').hidden = true;
        console.error('[estudio]', e);
        aviso('Erro', 'Algo deu errado ao gerar sua arte :( Verifique sua conexão e tente de novo.');
      });
  }

  /* ---------------------------------------------------------- quantidades */
  var qtdEl = $('[data-qtd]'), qtdFundo = $('[data-qtd-fundo]');
  function abrirQuantidades() {
    desenharQuantidades();
    qtdEl.hidden = false; qtdFundo.hidden = false;
    $('[data-qtd-erro]').hidden = true;
  }
  function fecharQuantidades() { qtdEl.hidden = true; qtdFundo.hidden = true; }
  qtdFundo.addEventListener('click', fecharQuantidades);
  function desenharQuantidades() {
    var lista = S.projetos.map(function (p, i) { return { p: p, i: i }; }).filter(function (x) { return x.p.envio && temArte(x.p); });
    $('[data-qtd-cards]').innerHTML = lista.map(function (x) {
      var p = x.p, m = MODELOS[p.cai], lados = p.envio.lados, lado = lados[0];
      var foto = p.previaLocal[lado] || p.envio.urls['previa-' + lado] || base(p, lado).img;
      return '<div class="pc" data-pc="' + x.i + '">' +
        '<div class="pc__topo"><h3>' + esc(m.nome + ' ' + cor(p.cor).nome) + '</h3><button type="button" class="pc__rm" data-pc-rm title="Remover">' + ico('lixo') + '</button></div>' +
        '<div class="pc__corpo"><div class="pc__fotos"><img src="' + esc(foto) + '" alt="Prévia" data-pc-foto>' +
        (lados.length > 1 ? '<div class="pc__lados">' + lados.map(function (l, j) { return '<button type="button" class="' + (j ? '' : 'on') + '" data-pc-lado="' + l + '">' + (l === 'frente' ? 'Frente' : 'Costas') + '</button>'; }).join('') + '</div>' : '') +
        '</div><div>' +
        '<div class="tams">' + TAMANHOS.map(function (t) {
          var v = variante(p.cai, p.cor, t), q = p.qtd[t] || '';
          return '<label>' + t + '<input type="number" min="0" max="99" inputmode="numeric" data-tam="' + t + '" value="' + q + '"' + (v ? '' : ' disabled') + ' placeholder="0"></label>';
        }).join('') + '</div>' +
        '<div class="pc__sub"><span class="pc__cada">' + brl(preco(p.cai)) + '/cada</span><strong class="pc__total" data-pc-total></strong></div>' +
        '<p class="pc__info">Estampa: ' + esc(ladosTexto(lados)) + ' · Código da arte ' + esc(p.envio.id) + '</p>' +
        (p.envio.alertas.length ? '<p class="pc__alerta">A imagem “' + esc(p.envio.alertas.join('”, “')) + '” está com resolução baixa para o tamanho escolhido e pode sair sem nitidez. Se tiver um arquivo maior, vale trocar.</p>' : '') +
        '</div></div></div>';
    }).join('');
    somar();
  }
  function somar() {
    var pecas = 0, total = 0;
    $$('[data-pc]').forEach(function (card) {
      var p = S.projetos[Number(card.dataset.pc)], n = 0;
      $$('[data-tam]', card).forEach(function (inp) {
        var v = Math.max(0, Math.min(99, parseInt(inp.value, 10) || 0));
        p.qtd[inp.dataset.tam] = v; n += v;
      });
      var t = n * preco(p.cai); pecas += n; total += t;
      $('[data-pc-total]', card).textContent = brl(t);
    });
    $('[data-qtd-pecas]').textContent = pecas + (pecas === 1 ? ' peça' : ' peças');
    $('[data-qtd-total]').textContent = brl(total);
    $('[data-acao="continuar"]').disabled = pecas < 1;
    salvar();
  }
  $('[data-qtd-cards]').addEventListener('input', function (e) { if (e.target.matches('[data-tam]')) somar(); });
  $('[data-qtd-cards]').addEventListener('click', function (e) {
    var card = e.target.closest('[data-pc]'); if (!card) return;
    var i = Number(card.dataset.pc), p = S.projetos[i];
    var l = e.target.closest('[data-pc-lado]');
    if (l) {
      $$('[data-pc-lado]', card).forEach(function (b) { b.classList.toggle('on', b === l); });
      $('[data-pc-foto]', card).src = p.previaLocal[l.dataset.pcLado] || p.envio.urls['previa-' + l.dataset.pcLado];
      return;
    }
    if (e.target.closest('[data-pc-rm]')) {
      aviso('Remover estampa', 'Quer remover “' + MODELOS[p.cai].nome + ' ' + cor(p.cor).nome + '” do seu projeto?', [{ t: 'Cancelar' }, { t: 'Remover', perigo: true }]).then(function (r) {
        if (r !== 1) return;
        removerProjeto(i);
        if (!S.projetos.some(function (x) { return x.envio && temArte(x); })) fecharQuantidades(); else desenharQuantidades();
      });
    }
  });
  function removerProjeto(i) {
    guardarLado();
    S.projetos.splice(i, 1);
    if (!S.projetos.length) { S.atual = -1; canvas.remove.apply(canvas, canvas.getObjects()); desenharProjetos(); salvar(); fecharQuantidades(); abrirProdutos('novo'); return; }
    S.atual = -1; abrirProjeto(Math.min(i, S.projetos.length - 1));
  }
  function continuar() {
    var botao = $('[data-acao="continuar"]'), erro = $('[data-qtd-erro]');
    somar();
    var items = [];
    S.projetos.forEach(function (p) {
      if (!p.envio || !temArte(p)) return;
      var ls = p.envio.lados, u = p.envio.urls;
      TAMANHOS.forEach(function (t) {
        var q = p.qtd[t] || 0, v = variante(p.cai, p.cor, t);
        if (!q || !v) return;
        var props = { 'Personalização': p.envio.id, 'Estampa': ladosTexto(ls), '_previa': u['previa-' + ls[0]] || '' };
        if (ls.length > 1 && u['previa-costas']) props._previa_costas = u['previa-costas'];
        items.push({ id: v.id, quantity: q, properties: props });
      });
    });
    if (!items.length) return;
    botao.disabled = true; botao.textContent = 'Adicionando…'; erro.hidden = true;
    fetch(D.cartAdd, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Não foi possível adicionar à sacola.'); return j; }); })
      .then(function () {
        S.projetos.forEach(function (p) { p.qtd = {}; });
        salvar();
        setTimeout(function () { window.location.href = D.carrinho; }, 350);
      })
      .catch(function (e) {
        botao.disabled = false; botao.textContent = 'Continuar';
        erro.textContent = e.message || 'Não foi possível adicionar à sacola. Tente de novo.'; erro.hidden = false;
      });
  }

  /* --------------------------------------------------------------- ações */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-acao]'); if (!b) return;
    switch (b.dataset.acao) {
      case 'menu': var mn = $('[data-menu]'); mn.hidden = !mn.hidden; b.setAttribute('aria-expanded', String(!mn.hidden)); break;
      case 'aba': $('[data-menu]').hidden = true; abrirPainel(b.dataset.aba); break;
      case 'recomecar':
        $('[data-menu]').hidden = true;
        aviso('Começar do zero', 'Isso apaga todas as estampas que você criou neste aparelho.', [{ t: 'Cancelar' }, { t: 'Apagar tudo', perigo: true }]).then(function (r) {
          if (r !== 1) return;
          S.projetos = []; S.atual = -1; canvas.discardActiveObject(); canvas.remove.apply(canvas, canvas.getObjects());
          try { localStorage.removeItem(CHAVE); } catch (err) {}
          desenharProjetos(); desenharFerramentas(); abrirProdutos('novo');
        });
        break;
      case 'fechar-painel': fecharPainel(); break;
      case 'enviar-imagem': arquivoEl.click(); break;
      case 'trocar-modelo': abrirProdutos('trocar'); break;
      case 'novo': case 'outra': fecharQuantidades(); abrirProdutos('novo'); break;
      case 'cores': abrirCores(); break;
      case 'mao': alternarMao(!S.mao); break;
      case '3d': abrir3d(); break;
      case 'baixar': baixar(); break;
      case 'concluir': concluir(); break;
      case 'fechar-qtd': fecharQuantidades(); break;
      case 'continuar': continuar(); break;
    }
  });
  $$('[data-lado]').forEach(function (b) { b.addEventListener('click', function () { trocarLado(b.dataset.lado); }); });

  /* --------------------------------------------------------------- início */
  function iniciarCanvas() {
    // Fabric 5 usa 'alphabetical' (inválido no Chrome atual, que avisa no console a cada letra)
    fabric.Text.prototype._setTextStyles = function (ctx, charStyle, forMeasuring) {
      ctx.textBaseline = 'alphabetic';
      if (this.path) ctx.textBaseline = { center: 'middle', ascender: 'top', descender: 'bottom' }[this.pathAlign] || 'alphabetic';
      ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    };
    fabric.Object.prototype.set({
      transparentCorners: false, cornerColor: '#173B2F', cornerStrokeColor: '#FFFFFF', borderColor: '#173B2F', cornerStyle: 'circle',
      cornerSize: toque ? 22 : 14, touchCornerSize: 34, borderScaleFactor: 1.4, padding: 4, borderDashArray: null
    });
    fabric.Object.prototype.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false });
    canvas = new fabric.Canvas($('[data-canvas]'), {
      preserveObjectStacking: true, controlsAboveOverlay: true, stopContextMenu: true, allowTouchScrolling: false,
      selectionColor: 'rgba(23,59,47,.08)', selectionBorderColor: '#173B2F', selectionLineWidth: 1, targetFindTolerance: toque ? 10 : 4
    });
    canvas.clipPath = new fabric.Rect({ left: 0, top: 0, width: AREA.w, height: AREA.h, absolutePositioned: true });
    ['selection:created', 'selection:updated', 'selection:cleared'].forEach(function (ev) { canvas.on(ev, function () { desenharFerramentas(); desenharCamadas(); }); });
    canvas.on('object:modified', function (e) { if (e.target) avisarResolucao(e.target); depoisDeMudar(); });
    canvas.on('text:changed', depoisDeMudarSemFerramentas);
    canvas.on('mouse:dblclick', function (e) { if (e.target && e.target.type === 'image' && !e.target.travado) abrirRecorteObjeto(e.target); });
    canvas.on('text:editing:exited', depoisDeMudar);
    canvas.on('after:render', function () { if (proj() && !arrasto) miniatura(); });
  }

  el.corpo.classList.toggle('sem-painel', !S.painel);
  if (!S.painel) el.painel.hidden = true; else abrirPainel(S.painel);
  desenharCards();

  carregarScript(D.fabric).then(function () {
    iniciarCanvas();
    return restaurar();
  }).then(function (restaurou) {
    if (!restaurou) abrirProdutos('novo');
    layout();
  }).catch(function (e) {
    console.error('[estudio]', e);
    aviso('Erro', 'Não foi possível abrir o estúdio agora. Recarregue a página.');
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) layout(); });
})();
